import { render } from "./Saving_Deposits.vue?vue&type=template&id=01a34872"
import script from "./Saving_Deposits.vue?vue&type=script&lang=js"
export * from "./Saving_Deposits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__